import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { COMPONENTS } from '../../../routers/constants'
import { SETTING_KEYS } from '../constant'
import { SettingItem } from './SettingItem'

export const IndustryAndMacro = () => {
  return (
    <Panel label="alertSetting.INDUSTRY_AND_MACRO_SETTINGS" isI18n>
      <div style={{ padding: '0px 12px' }}>
        <SettingItem
          isIndustry
          settingKey={SETTING_KEYS.INDUSTRY}
          settingEmailKey={SETTING_KEYS.INDUSTRY_EMAIL}
          title="alertSetting.INDUSTRY_ALERTS"
          description="alertSetting.INDUSTRY_ALERTS_DESC"
          additionalDesc={
            <Element elementName="span" style={{ color: '#2C73E8' }}>
              <Link
                to={
                  COMPONENTS.userManagement.components.settingsPreferences.route
                }
                target="_blank"
              >
                <Translate value="alertSetting.INDUSTRY_ALERTS_DESC2" />
              </Link>
              {'.'}
            </Element>
          }
        />
        <SettingItem
          settingKey={SETTING_KEYS.MACRO}
          settingEmailKey={SETTING_KEYS.MACRO_EMAIL}
          title="alertSetting.MACROECONOMIC_ALERTS"
          description="alertSetting.MACROECONOMIC_ALERTS_DESC"
        />
      </div>
    </Panel>
  )
}
